import React from "react";
import { useTranslation } from "react-i18next";
import AccordionBox from "components/Layouts/AccordionBox";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from "@mui/material";
import { dateDifference, isoDateWithoutTimeZone } from "helpers/utils";

function PeopleTile({ classes, data = [], customCaptions }) {
	const { t } = useTranslation();
	return (
		<AccordionBox title={t("title.people")}>
			<div className={classes.inputContainer}>
				<Table>
					<TableHead className={classes.tableHead}>
						<TableRow>
							<TableCell style={{ width: "170px" }}>
								{customCaptions?.user}
							</TableCell>
							<TableCell>{t("label.startTime")}</TableCell>
							<TableCell>{t("label.endTime")}</TableCell>
							<TableCell>{t("label.totalTime")}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data?.length ? (
							data?.map((row) => (
								<TableRow key={row?.id}>
									<TableCell style={{ width: "170px" }}>
										{row?.displayName}
									</TableCell>
									<TableCell style={{ width: "170px" }}>
										{isoDateWithoutTimeZone(row?.startDate + "Z")}
									</TableCell>
									<TableCell style={{ width: "170px" }}>
										{row?.endDate && row.endDate !== "null"
											? isoDateWithoutTimeZone(row.endDate + "Z")
											: ""}
									</TableCell>
									<TableCell style={{ width: "170px" }}>
										{dateDifference(row?.endDate, row?.startDate)}
									</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell>{t("message.noRecordsFound")}</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</div>
		</AccordionBox>
	);
}

export default PeopleTile;
